(function($) {
  $.fn.numberField = function() {
    $(this).each(function () {
      if ($(this).closest(".editortable table, table.editortable").length == 0)
        $(this).autoNumeric('init', { aSign: '', vMin: '-999999999', mDec: 0 });
    });
  };
})(jQuery);
